import _toConsumableArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import * as S from '@effect/schema/Schema';
import { BannerBlockConfig } from './leafs/banner/codecs';
import { LeafBlockConfigs } from './leafs/codecs';
import { HtmlBlockConfig } from './leafs/html/codecs';
export { LeafBlockConfigs };
var LeafBlockConfig = S.union.apply(S, _toConsumableArray(Object.values(LeafBlockConfigs)));
var LayoutBlockConfig = S.lazy(function () {
  return S.union(ColumnBlockConfig, EntityBannerBlockConfig, PortalBlockConfig, StickyBlockConfig, MediaQueryBlockConfig);
});
export var BlockConfig = S.union(LayoutBlockConfig, LeafBlockConfig);
export var ColumnBlockConfig = S.struct({
  typename: S.literal('ColumnBlock'),
  id: S.string,
  hash: S.string,
  widths: S.array(S.number),
  columns: S.array(S.array(BlockConfig))
});
export var EntityBannerBlockConfig = S.struct({
  typename: S.literal('EntityBannerBlock'),
  id: S.string,
  hash: S.string,
  fallback: S.nullable(S.union(HtmlBlockConfig, BannerBlockConfig))
});
export var MediaQueryBlockConfig = S.struct({
  typename: S.literal('MediaQueryBlock'),
  id: S.string,
  hash: S.string,
  mediaQuery: S.nullable(S.string),
  blocks: S.array(BlockConfig)
});
export var PortalBlockConfig = S.struct({
  typename: S.literal('PortalBlock'),
  id: S.string,
  hash: S.string,
  blocks: S.array(BlockConfig),
  mountID: S.string
});
export var StickyBlockConfig = S.struct({
  typename: S.literal('StickyBlock'),
  id: S.string,
  hash: S.string,
  blocks: S.array(BlockConfig),
  positionBottom: S.nullable(S["boolean"])
});